import React, { useState, useEffect } from "react";
import { getAllBrands, getAllCauses } from "../../services/campaign";
import Link from "next/link";
import Image from "next/image";
export const baseURL = `${process.env.BASE_URL}/`;
import { topCauses } from "../../data/collection_data";
import { errorToast } from "../../utils/toast";
import { uniqueFilter } from "../../utils/filters";

const tempCauses = {
  success: true,
  causeList: [
    {
      _id: "6345ecf6528436ae8b37f176",
      userId: "6345ead9528436ae8b37f153",
      isFeatured: true,
      name: "Girls School of Austin",
      logoUrl:
        "public/displayImages/cover_1678726952044_363478_ba0e9375-9dcd-47a9-b71a-a0f8428d0f85.png",
      about:
        "Girls School of Austin is a non profit committed to quality education",
      country: "United States",
      city: "Austin",
      category: "Education",
      websiteUrl: "https://petdropsnft.io/",
      socials: ["https://petdropsnft.io/"],
      isRegistered: true,
      registrationNum: 742963379,
      countryOfRegistration: "US",
      activeCampaigns: [],
    },
    {
      _id: "63e00bddc040bbe49f9b001d",
      userId: "63d6f0d97bf683b8c836c266",
      logoUrl:
        "public/user/avatars/avatar_1678726710793_597504_d60d6b25-a036-47d4-b864-f763ca909b34.png",
      coverUrl:
        "public/displayImages/cover_1675611748769_181690_CopyofUntitled(1).png",
      isFeatured: false,
      name: "Oxford Dog Training",
      about:
        "We help humans and their furry friends and furbabies! We also support a number of dog shelters and work with dogs that others give up on!",
      country: "United Kingdom",
      city: "Oxford",
      category: "Animal Welfare",
      websiteUrl: "https://www.oxforddogtrainingcompany.com/",
      socials: [
        "https://www.facebook.com/BearMartialArts",
        "https://www.instagram.com/oxforddogtraining/",
      ],
      isRegistered: false,
      registrationNum: 0,
      countryOfRegistration: "",
      activeCampaigns: [
        {
          _id: "6447f0f11fbc6ac0dfdbdde7",
          overview: {
            campaignName: "NFT YOUR DOG",
            campaignType: "OPEN",
            description:
              "This is for dog lovers all around the world! And... you don't need to know what an NFT is or how to create one. It's really easy to get involved, all you need is an image of your dog that you love, that will forever be linked to a digital token, (that's the NFT) AND when you buy the NFT you'll be supporting a dog in need, and possibly save it's life. \r\n\r\nThe harsh reality is that euthanasia is common 'solution' for dogs with behavioral issues, often only because they've had limited socialization or training, and because their owners have had limited instruction on how to integrate their fur babies into the world. \r\n\r\nWe want to help give these amazing companions a fighting chance by working with animal shelters to offer training and support for pups and hopefully their new forever humans. \r\n\r\nFor every $300 that we earn from your NFT creations and sales we will support 10 dogs in an animal shelter with socialization and training. 10 % of earnings will also be donated to the animal shelter for other resources that they need. \r\n\r\nSteps to help:\r\n1) Just sign up\r\n2) Verify your account, (you have to get verified through the Stripe payment gateway because on this platform, people can earn from NFT creations and sales too so if you chose to support a campaign and earn from sales they need a way to pay you!\r\n3) On our campaign page, click on Contribute an NFT, and add the details for the image, choose what percentage of the sale you want to give to our campaign, (if you're buying the NFT or you don't want to earn from the sale, please choose 100%), and click on create.\r\n4)Once you've created the image, you can then buy it, or share it with your network for someone else to purchase and support our campaign. \r\n\r\nWe really hope that you will support us on this. The pup you love can help save others! \r\n\r\nP.S. If you want to add some cool effects to your images before you add them, there are lots of free online options to do that, including one called Nightcafe studio (creator.nightcafe.studio) which gives you free credits. ",
            startDate: "2023-05-26T12:23:30.000Z",
            endDate: "2024-03-31T12:23:30.000Z",
            bannerImageUrl: [
              "public/uploads/identityVerifications/banner_1682436337463_597427_89e40922-0202-4340-99dd-db6de5cc4dfe.png",
            ],
            isSuperCampaign: false,
            isSubCampaign: true,
            superCampaignId: "64181f64c1877fb6b1264456",
            superCampaignName: "PetDrops",
            country: "United Kingdom",
          },
        },
      ],
    },
    {
      _id: "63e004f4c040bbe49f9aff9e",
      userId: "63d6f06a7bf683b8c836c25b",
      logoUrl:
        "public/displayImages/logo_1675609316170_755481_CopyofUntitled(170Ã170px)(1).png",
      coverUrl:
        "public/displayImages/cover_1675609316172_318695_Untitleddesign(4).png",
      isFeatured: false,
      name: "AdventureLOGUE",
      about:
        "Adventurelogue travel diary is the the travel diary with a soul. We cherish the joy of traveling alongside a commitment to protecting the amazing places we visit. We are proud to support global charities such as  REST, Project Peru, We Love Underdogs, REST, Little Fireface Project, Vital Underground and Traffic",
      country: "United Kingdom",
      city: "Oxford",
      category: "Environment",
      websiteUrl: "www.adventurelogue.co.uk",
      socials: ["https://www.facebook.com/Adventurelogue"],
      isRegistered: false,
      registrationNum: 0,
      countryOfRegistration: "",
      activeCampaigns: [
        {
          _id: "63f51a90c040bbe49f9b0dba",
          overview: {
            campaignName: "A World of Wonder",
            campaignType: "CLOSED",
            description:
              "Many of us have been incredibly lucky to see as much of the world as we have and the more we see the more aware we become of the unique needs and diverse challenges of different places. Adventurelogue was a way to combine the love of travel with a means to give back to the communities and destinations that make traveling so addictive for us. Our proceeds support projects like Project Peru (check out our website for more info https://adventurelogue.co.uk) and if you support with the purchase of an NFT, we can either donate a travel diary to a refuge or shelter, or we can post it out to you if you're in the UK. Please contact us for shipping costs overseas. Additionally, all NFTs sold on our campaign will also give you access to an online concert and metaverse festival with some great talents (more info coming soon!) and you can find out more here https://www.aunuaglobal.org/positive-vibes",
            startDate: "2023-02-21T20:47:12.000Z",
            endDate: "2023-11-30T17:47:12.000Z",
            bannerImageUrl: [
              "public/uploads/identityVerifications/banner_1677007504495_840448_adveturelogue(920Ã411px).png",
            ],
            isSuperCampaign: false,
            isSubCampaign: true,
            superCampaignId: "63c42a6b4df378abfe55cd84",
            superCampaignName: "AUNUA POSITIVE VIBES",
            country: "United Kingdom",
          },
        },
      ],
    },
    {
      _id: "640b37dfc1877fb6b1263641",
      userId: "640b2de3c1877fb6b126361e",
      logoUrl:
        "public/displayImages/logo_1678456799394_608302_cfa8b911-e5cd-4c1b-92b0-4c99dc8479fd.jpg",
      coverUrl:
        "public/displayImages/cover_1678456799395_867591_636b748c-16b4-4cf6-b8dc-eafdb993b361.jpg",
      isFeatured: false,
      name: "We Rise Together Foundation",
      about:
        "We are an organization that works on many environmental and social issues through three initiatives. 1. SundayforSecuredFuture: whereby we encourage youngsters to take positive action for the climate, every Sunday. We have planted around 2000 trees under this initiative to date.\r\n\r\n2. She Hygiene: focuses on distributing bio-degradable sanitary pads to girls who cannot afford to buy this basic necessity. We are currently providing 300 girls with these pads per month. To date, we have donated over 5000 pads.\r\n\r\n3. Helping Hands: encourage people to give us items such as clothes, books, shoes, food, etc which we donate to uneducated children. We have given 1500 books that have become a source of education and entertainment for many.\r\n",
      country: "India",
      city: "Ghaziabad",
      category: "Human Services",
      websiteUrl: "https://werisetogetherfoundation.online/",
      socials: [
        "https://l.instagram.com/?u=https%3A%2F%2Flinktr.ee%2Fwerisetogetherfoundation&e=AT2DrKA5ujnbK8kFrkKOyYoyy0dOFBLR_LxzLTZRImoro8r3PPC6g0draCl0N18Z3ZbZVAtlGISi683YBuicVAAbC5D5jwq9D9r-O4o",
      ],
      isRegistered: true,
      registrationNum: "U85300UP2021NPL148300",
      countryOfRegistration: "India",
      activeCampaigns: [],
    },
    {
      _id: "6426ff0ded37fd0e36794981",
      userId: "6426ee0bed37fd0e367948d3",
      logoUrl:
        "public/displayImages/logo_1680277260937_222501_1e60d032-4775-4c42-80ee-c155fc16d46f.jpg",
      coverUrl:
        "public/displayImages/cover_1680277260958_743006_32df07fb-ea93-40cd-b888-2c20cfa6aac9.jpg",
      isFeatured: false,
      name: "WOMENS EDUCATION DEVELOPMENT SOCIETY",
      about:
        "1) EXECUTIVE SUMMERY:\r\nWomen’s Education Development Society (WEDS) is a Non-profit, Grass root level organization in local, Non-Governmental organization registered Under Indian Society Act, Registered number is 129/92 and functioning From 8th October, 1992 and Registered foreign contribution regulation act (FCRA) Dindigul District and Tamilnadu, India.\r\nThe Vision of the WEDS is uplifting the standard of living of the poor marginalized downtrodden community people and mainstreaming them through education and economic empowerment. WEDS Fields of activities are in education, women development health, environment, water and sanitation income Generation and social aspect to uplift the poor, marginalized and downtrodden people.\r\nWEDS has a very good report with the community leaders and local leaders and plan, implement the activities in consultation and participation of local community. It has developed a participatory evaluation system in which the community auditing of the programme is a part with all these capabilities the WEDS wish to take up the project “Empowerment Of The Youth Women Through Tailoring Skill Training Project”.",
      country: "India",
      city: "Dindigul",
      category: "Arts & Culture",
      websiteUrl: "www.wedsindia.org",
      socials: ["https://www.facebook.com/weds.ngo/"],
      isRegistered: true,
      registrationNum: "129/1992",
      countryOfRegistration: "India",
      activeCampaigns: [],
    },
    {
      _id: "641b1460ff96c10593df686b",
      userId: "64196a4564cc93bb1d745bb1",
      logoUrl:
        "public/displayImages/logo_1679493852072_312463_44937a0e-f216-4821-b9c6-f924857df499.jpg",
      coverUrl:
        "public/displayImages/cover_1679493852073_552376_57431410-8b32-44c9-aa00-10eaf844ee1d.jpg",
      isFeatured: false,
      name: "Bishara care Movement",
      about:
        "It specializes in Girl child education and empowerment. In my community the girl child rights have been neglected not only is the issue on a negatively trend but also faces barrier to education caused by poverty, cultural norm, and Harmful practices, poor infrastructure, violence and fragility. Thus, I came up with the idea of starting Bishara care Movement and decided to put my energy and time in it so as to help these girls and also to give back to my community. Being a victim to Female Genital mutilation (FGM)I got motivated to this kind of vice. I started this programme in 2018 By creating awareness on social media platforms, visiting institutions and approaching people in remote areas within my own community. Ensuring that all girls receive a quality education, protected against harmful practice such female circumcision, Early and forced marriage. Gain social emotional and life skills necessary to navigates and adapt to a changing world, making decision about their own lives and contribute to the community and the world.",
      country: "Kenya",
      city: "Mombasa",
      category: "Education",
      websiteUrl: "https://bisharahamo.weebly.com/",
      socials: ["https://www.facebook.com/bishara011?mibextid=ZbWKwL"],
      isRegistered: false,
      registrationNum: "",
      countryOfRegistration: "",
      activeCampaigns: [],
    },
    {
      _id: "641ee6faff96c10593df779a",
      userId: "641addefff96c10593df6507",
      logoUrl:
        "public/displayImages/logo_1679746809908_846081_8498d09a-ec9c-4d7b-bc2f-5095eda10c58.jpg",
      coverUrl:
        "public/displayImages/cover_1679746809908_614324_434c0fde-adf4-49d8-8e24-5a714b67e9cb.jpg",
      isFeatured: false,
      name: "YOUTH AND CHILDREN EDUCATION",
      about:
        "Glorious Foundation Tanzania, is a non-profit and registered  organization Located in maasai societies at Mirongoine and Oljoro Village, Oljoro Ward, Arusha Region with the mission of promoting community development in our country through poverty alleviation strategies.\n\nOur main focus is to provide children and families  with quality and accessible education at Mirongoine village,Oljoro village,Mbuyuni village Arusha Region Tanzania.\n  \nAfter received our Organization Certification as a registered charity, we started asking for donations from Peace groups and home donors. This helped us to buy three acres of land for the construction of pre and primary school buildings like classrooms,library room,dining hall,Administration block and compiuter room. \n\nThis achievement of having a purchased land encouraged us to dream  bigger, since there was still a long way to go to fulfill one of our most ambitious objectives as an organization.",
      country: "Tanzania",
      city: "Arusha",
      category: "Children",
      websiteUrl: "http://www.gloriousfoundation.or.tz",
      socials: ["http://www.instagram.com/save_children_education"],
      isRegistered: true,
      registrationNum: "OONGO/R/1094",
      countryOfRegistration: "Tanzania",
      activeCampaigns: [
        {
          _id: "643179e5d001d4fd2f5e63e5",
          overview: {
            campaignName: "Road to Education ",
            campaignType: "OPEN",
            description:
              "We want to buy a school bus for vulnerable kids to help them reach school in the morning. Children from age 3 have to walk over 7km to get to our charity school where we provide free education, meals and resources. \n\nWe need lots of support but we think a bus is a priority to start as these children face many dangers on the walk and some have to leave home at 5am to get to school at 8:30am and then get home at 7:30pm. \n\nA school bus will cost $12,821 and we hope that you will buy the art which will show your support for us and when you buy the kids art it will also be a ticket to the positive vibes festival - see positivevibesglobal.com \n\nWe can make a difference to these children’s lives. ",
            startDate: "2023-05-01T07:26:00.000Z",
            endDate: "2023-12-31T10:30:00.000Z",
            bannerImageUrl: [
              "public/uploads/identityVerifications/banner_1680964069102_585789_1a7d6211-d174-41bd-b180-e662d2286e0a.jpg",
            ],
            isSuperCampaign: false,
            isSubCampaign: true,
            superCampaignId: "63c42a6b4df378abfe55cd84",
            superCampaignName: "AUNUA POSITIVE VIBES",
            country: "Tanzania",
          },
        },
      ],
    },
    {
      _id: "6418a5d6c1877fb6b1264603",
      userId: "64186e17c1877fb6b1264545",
      logoUrl:
        "public/displayImages/logo_1679336918695_342911_f85db2ec-582f-4538-a259-45140b1f9b23.png",
      coverUrl:
        "public/displayImages/cover_1679336918696_627108_e29a7bb7-4aa4-427a-b975-08a4cb934e39.jpg",
      isFeatured: false,
      name: "Youth Underground",
      about:
        "Youth Underground is a trademarked Swiss Nonprofit Association formed in accordance with articles 60 ff of the Swiss Civil Code, representing the voice of the youth for a world without human trafficking. It is a global education, information-sharing and advocacy platform, a knowledge and youth hub, to showcase initiatives against human trafficking by the youth, as advocates of change and defenders of human rights across age and frontier. Through youth education about human trafficking, Youth Underground is a sounding board and a safe space for the youth to express themselves, speak out freely about human trafficking, share information they learn as well as news and campaigns from their regions of the world. We believe that youth education is where the prevention of human trafficking begins, and this is at the core of all our work.",
      country: "Switzerland",
      city: "Geneva",
      category: "Education",
      websiteUrl: "https://youth-underground.com/",
      socials: [
        "https://twitter.com/youthundg",
        " https://www.instagram.com/youth.underground/",
        " https://www.youtube.com/channel/UCjmd1dQIhXFBlyMAwix0T6A",
        " https://www.linkedin.com/company/youth-underground%E2%84%A2/",
      ],
      isRegistered: true,
      registrationNum: "60.975.009",
      countryOfRegistration: "Switzerland",
      activeCampaigns: [],
    },
    {
      _id: "644d3dbb4d7c29c3de5844a7",
      userId: "6409c469c1877fb6b1263492",
      logoUrl:
        "public/displayImages/logo_1682783674855_530368_8c5a9c95-a606-4647-827f-40c901f4a60e.png",
      coverUrl:
        "public/displayImages/cover_1682783674855_651710_883884a7-c384-4eea-9658-cd9ac8468f31.png",
      isFeatured: false,
      name: "Think Ocean",
      about:
        "Think Ocean's roots lie with a group of environmentalists who in 1992, united several organizations towards a common goal; to stop the whale hunting in the\r\nSouth Pacific, ending with the co-creation of the Southern Ocean Whale Sanctuary in 1995. Founding members continued working on environmental projects\r\nglobally, including San Antonio Wildlife Rescue Centre, “El Nino current” Pacific Ocean emergency and expanded focus in supporting organizations tackling whale\r\nhunting, deforestation, wildlife trafficking, conservation and the adoption of CITES treaty of Latin America. One of these founding members, seeing the impact of\r\npollution, particularly plastic pollution on the oceans, went on to form Think Ocean in the UK, with the intention of addressing the plastic pollution crisis. Recognising that water is life, the focus expanded to protecting water ecosystems and tackling plastic pollution before it gets to the ocean, protecting inhabitants, human and otherwise, around these the arteries of our planet. Our focus is on awareness raising, education, technology to  scale solutions and collaborative action for impact. Join us on our mission! Visit thinkocean.earth",
      country: "United Kingdom",
      city: "Derby",
      category: "Environment",
      websiteUrl: "www.thinkocean.earth",
      socials: ["www.thinkocean.earth"],
      isRegistered: true,
      registrationNum: "13453299",
      countryOfRegistration: "United Kingdom",
      activeCampaigns: [
        {
          _id: "644e1ba84d7c29c3de584700",
          overview: {
            campaignName: "Water for Life",
            campaignType: "OPEN",
            description:
              "THE CONTEXT:\nWe have come a long way over the last year, and we have the opportunity to do so much more, but trying to get everything done with limited resources and while working as volunteers, has been tough. We have two major initiatives that we would love support on, one that focuses on education and the other on technology. \n\nEDUCATION:\nWith the education program, Embark is interested in working with us so that we might develop an environmental education program. The aim would be  to support students, initially in a pilot followed by a rollout to 38 schools with education, practical skills and collaborative experiences through accelerators and incubators to raise awareness of the challenges, and to accelerate development of solutions. We want to develop this program with them and then be able to support schools and programs everywhere, both in the UK and internationally to do the same, creating a ripple effect of behavioural change and rapid solution deployment. \n\nWe are looking to raise £25 000 to support with the initial development, pilot and rollout of the program. \n\nTECHNOLOGY:\nThe second area that we need support with, is to help us develop technology that will clean rivers and prevent plastic from reaching the ocean. Existing solutions focus just on the river surface, but we are working in partnership to develop a technology that also lifts and captures plastic from the riverbed. We are finalizing this project and will run a separate campaign for this in time, but would love for you to get in touch if you would like to partner, sponsor or support in some other way. \n\nHOW TO GET INVOLVED:\n1) Buy an image, when you do it will be an NFT that will build your impact portfolio and impact profile. Show the world what you stand for.\n2) Share an original image of yours- something that is water themed, it could be a drawing, a photo, some AI art, and promote it so that it sells. Even if it's just for $10, every small amount matters so help us to save the world! NB- YOU CAN EARN FROM IMAGES WHEN THEY SELL & YOU CAN ALSO OFFER BUYERS ADDITIONAL VALUE FROM THE IMAGES (for example anyone who buys the image also gets a physical item, or access to an experience or a product or service).\n3) Run your own sub-campaign under our super campaign to fundraise for water initiatives and programs. Anything that is focused on protecting our water resources, fresh water and salt water... and the ecosystems around them. We want to give you a voice and a means to do this. Remember, you don't need to know anything about NFTs, and you can get others to contribute too. \n\nNote: If you're a school or a youth organisation, run an activity day to fundraise for any of your impact activities and for us too :) You can also get involved in the Positive Vibes Movement. Get in touch to find out more. \n\nFind us at thinkocean.earth\n",
            startDate: "2023-05-01T04:39:17.000Z",
            endDate: "2024-09-30T04:39:17.000Z",
            bannerImageUrl: [
              "public/uploads/identityVerifications/banner_1682840487380_582018_3397b0b7-fbfa-49b3-8410-d739cf41a969.png",
            ],
            isSuperCampaign: true,
            isSubCampaign: false,
            superCampaignId: "",
            superCampaignName: "",
            country: "United Kingdom",
          },
        },
      ],
    },
    {
      _id: "6416bca9c1877fb6b1263fa3",
      userId: "641023bdc1877fb6b126390a",
      logoUrl:
        "public/displayImages/logo_1678780165239_526785_405a2bc9-d2bd-4553-89ad-5547746df7c5.jpg",
      coverUrl:
        "public/displayImages/cover_1678780165239_454397_2623a356-1eaf-46ee-92c9-09966fc774b1.jpg",
      isFeatured: false,
      name: "We Rise Together Foundation",
      about:
        "We Rise Together is a non-profit  organization that aims to resolve social and climate issues at a community level through three initiatives:\r\n1. SundayforSecuredFuture: whereby we encourage youngsters to take positive action for the climate, every Sunday. We have planted around 3000 trees under this initiative to date.\r\n\r\n2. She Hygiene: focuses on distributing bio-degradable sanitary pads to girls who cannot afford to buy this basic necessity. We are currently providing 250 girls with these pads per month. To date, we have donated over 5000 pads.\r\n\r\n3. Helping Hands: encourage people to give us items such as clothes, books, shoes, food, etc which we donate to uneducated children. We have given 1500 books that have become a source of education and entertainment for many.\r\n",
      country: "India",
      city: "Ghaziabad",
      category: "Health",
      websiteUrl: "https://werisetogetherfoundation.online/",
      socials: ["https://linktr.ee/werisetogetherfoundation"],
      isRegistered: true,
      registrationNum: "U85300UP2021NPL148300",
      countryOfRegistration: "India",
      activeCampaigns: [
        {
          _id: "64183c3bc1877fb6b12644ab",
          overview: {
            campaignName: "She Hygiene",
            campaignType: "OPEN",
            description:
              "She Hygiene is an initiative by We Rise Together that focuses on distributing bio-degradable sanitary pads to girls and women who cannot afford to buy these basic necessities and we also educate them regarding the importance of menstrual health. \r\n\r\nOur vision is to provide access to eco-friendly sanitary products to reduce the staggering numbers of schoolgirls dropping out because of unhygienic menstruation. We believe menstrual hygiene is a basic right, not a luxury. \r\n\r\nOur monthly target is to provide pads to  300 women and girls, every month, who struggle to practice safe and healthy menstrual hygiene.\r\n\r\nWe have conducted several drives in:\r\nslum areas, girls’ orphanages and  schools teaching deprived girls.\r\n\r\nThrough our educational sessions, we have broken down the taboo surrounding menstruation due to which our target audience is able to freely discuss their period problems and also encourage their friends, sister and mothers to use pads as well. \r\n\r\nThis has reduced their period problems and offered a better menstrual health to many.\r\n\r\nRecently, we have also started promoting the use of other sustainable options like Menstrual Cups.",
            startDate: "2023-03-21T00:03:52.000Z",
            endDate: "2023-12-20T00:03:52.000Z",
            bannerImageUrl: [
              "public/uploads/identityVerifications/banner_1679295021370_782963_5bf27f5d-317b-4bc6-a809-27ce66fab31a.jpg",
            ],
            isSuperCampaign: false,
            isSubCampaign: true,
            superCampaignId: "63c42a6b4df378abfe55cd84",
            superCampaignName: "AUNUA POSITIVE VIBES",
          },
        },
      ],
    },
    {
      _id: "63e0053fc040bbe49f9affa8",
      userId: "63d6eed57bf683b8c836c24a",
      logoUrl:
        "public/displayImages/logo_1675613725845_540936_CopyofUntitled(170Ã170px)(2).png",
      coverUrl:
        "public/displayImages/cover_1675613725845_223234_CopyofUntitled(1).png",
      isFeatured: false,
      name: "Bear Martial Arts",
      about:
        "We're committed to safety, security and good health- not just for us humans, but other creatures that inhabit the earth. We proudly support the  Libearty Bear Sanctuary in Romania which rescues bears from unsafe and poor conditions.",
      country: "United Kingdom",
      city: "Oxford",
      category: "Animal Welfare",
      websiteUrl:
        "https://www.bearmartialarts.com/spage-about_us-our_work_with_hauser_bears.html",
      socials: ["http://pinterest.com/bearmartialarts/"],
      isRegistered: false,
      registrationNum: 0,
      countryOfRegistration: "",
      activeCampaigns: [
        {
          _id: "6418152cc1877fb6b1264437",
          overview: {
            campaignName: "SaferWays Kids",
            campaignType: "CLOSED",
            description:
              "We want the world to be a safer place and are supporting SaferWays (see saferways.info) to develop a program called SaferWays Kids, developing fun info packs that teach kids about safety. In aid of this we are releasing our limited edition Bears. When you buy one of the Bear NFTs you also get a Bear Martial Arts t-shirt shipped out to you. Contact us through bearmartialarts.com with proof of your purchase and we'll arrange shipping, OR we can donate the tee to a local youth project. BONUS: Your NFT also gives you access to the Positive Vibes Festival in August! Check out positivevibesglobal.com for more info and updates. ",
            startDate: "2023-03-20T21:13:58.000Z",
            endDate: "2024-02-19T15:13:58.000Z",
            bannerImageUrl: [
              "public/uploads/identityVerifications/banner_1679263703208_968836_f4b94d81-b49b-47f6-9fe9-06cb90155c28.png",
            ],
            isSuperCampaign: false,
            isSubCampaign: true,
            superCampaignId: "63c42a6b4df378abfe55cd84",
            superCampaignName: "AUNUA POSITIVE VIBES",
            country: "United Kingdom",
          },
        },
      ],
    },
    {
      _id: "646367692079da1f93a1c2d6",
      userId: "64189faac1877fb6b12645a3",
      logoUrl:
        "public/displayImages/logo_1684236137563_396102_71f77716-e124-43fb-a3cb-154ee22179d6.jpg",
      coverUrl:
        "public/displayImages/cover_1684236137603_631725_7e514bcd-c61b-476c-bd60-d9f0015c6638.jpg",
      isFeatured: false,
      name: "Action For Equality",
      about:
        "We’ve come together as a group of refugees to help Afghan girls and young women overcome barriers to access of third level online learning opportunities (for undergraduate and graduate degrees). We have fled from war-torn areas, including Afghanistan and the Ukraine, but now in a safer place, believe that we have to stand up and do what we can to empower others.\r\n\r\n \r\n\r\nIn December 2022, an institutional decision was made through Taliban rule that banned girls and women from being able to access education. No debate or argument or lobbying has as yet changed this. \r\n\r\nWe embody the struggle for women's right, where education is one of the main and primary human rights. Afghanistan is the only country where girls and women do NOT have the right to study. Any protests are met with threats of physical harm. The psychological harm is constant. \r\n\r\nOur aim is to prevent the girls from extinguishing the dreams in their hearts. Education is the way to a better future and the realization of dreams. This is the main purpose of what we are doing. \r\n\r\nBy supporting our campaign, you open the door for many Afghan girls and",
      country: "Afghanistan",
      city: "Kabul",
      category: "Education",
      websiteUrl: "https://impactoverse.com/",
      socials: ["https://impactoverse.com/"],
      isRegistered: false,
      registrationNum: "",
      countryOfRegistration: "",
      activeCampaigns: [
        {
          _id: "648114bd2e4e15627b786187",
          overview: {
            campaignName: "Action for Equality",
            campaignType: "OPEN",
            description:
              "About the Cause \nWe’ve come together as a group of refugees to help Afghan girls and young women overcome barriers to access of third level online learning opportunities (for undergraduate and graduate degrees). We have fled from war-torn areas, including Afghanistan and the Ukraine, but now in a safer place, believe that we have to stand up and do what we can to empower others.\n\nIn December 2022, an institutional decision was made through Taliban rule that banned girls and women from being able to access education. No debate or argument or lobbying has as yet changed this. \nWe embody the struggle for women's right, where education is one of the main and primary human rights.  Afghanistan is the only country where girls and women do NOT have the right to study. Any protests are met with threats of physical harm. The psychological harm is constant. \nOur aim is to prevent the girls from extinguishing the dreams in their hearts. Education is the way to a better future and the realization of dreams. This is the main purpose of what we are doing. \nBy supporting our campaign, you open the door for many Afghan girls and women to realize their dreams.  You give a lifeline to hope and faith for a brighter future for them.  You create an opportunity for them to get out of a life of oppression and inequality.  Education should be a right, help us to make this a reality, prove that equality stands a chance. \nWe know that there are many who will say that there are lots of online courses that women can access, and there are also some universities that offer scholarships. This is a great resource BUT there are still barriers to accessing this. Even for those who have the technology, there is limited internet access, not because of internet not being available generally, but lack of funds to purchase data which is expensive. Even for girls who have good proficiency in English, they don’t have the means to get the English tests required that certifies their proficiency and allows for them to overcome this hurdle which is a pre-requisite for the university sponsored positions. We would love to be able to work with universities all around the world to be able to offer accredited opportunities for these girls and women, but to start we need to overcome these initial hurdles. \nWe would like to raise funds for the following:\n- Internet access for 60 girls and young women at $15 per month, for 3 months to complete the English certifications ($900 x 3: Total of $2700)\n- The IELTS test for 60 girls and young women at $200 per person (Total of $12 000) We would also welcome any test provider being able to sponsor these tests and universities and other training providers being able to offer subsidised positions. \nWe understand that there are many challenges but we have to try to make a difference. By supporting us, you support a fairer world, and you take a stand against inequality. \n",
            startDate: "2023-06-08T02:00:00.000Z",
            endDate: "2030-02-07T20:41:55.000Z",
            bannerImageUrl: [
              "public/uploads/identityVerifications/banner_1686181053140_688039_4bb666a5-5074-4673-a355-0dc82a5e496e.jpg",
            ],
            isSuperCampaign: false,
            isSubCampaign: false,
            superCampaignId: "",
            superCampaignName: "",
            country: "Afghanistan",
          },
        },
      ],
    },
  ],
};

const TopCauses = () => {
  const [loadingCauses, setLoadingCauses] = useState(true);
  const [campaign, setCampaign] = useState([]);
  const [filteredCampaigns, setFilteredCampaigns] = useState([]);
  const [filter, setFilter] = useState({
    category: [],
    name: [],
  });
  const [filterValue, setFilterValue] = useState({
    name: "",
    category: "",
    country: "",
  });

  useEffect(() => {
    getAllCauses()
      .then((res) => {
        setCampaign(tempCauses.causeList);

        setFilter({
          ...filter,
          category: uniqueFilter(
            tempCauses.causeList.map((item) => ({
              value: item.category.toLowerCase(),
              label: item.category.toLowerCase(),
            }))
          ),
          name: uniqueFilter(
            tempCauses.causeList.map((item) => ({
              value: item.name.toLowerCase(),
              label: item.name.toLowerCase(),
            }))
          ),
        });
      })
      .catch((error) => console.log("error", error));
    getAllCauses();
    // Simulate data loading delay
    const delay = setTimeout(() => {
      setLoadingCauses(false);
    }, 1000);

    // Clean up the timeout on component unmount
    return () => clearTimeout(delay);
  }, []);

  useEffect(() => {
    const { country, category, name } = filterValue;

    let filteredCampaigns = campaign;

    if (country) {
      filteredCampaigns = filteredCampaigns.filter(
        (item) => item.country.toLowerCase() === country.toLowerCase()
      );
    }

    if (name) {
      filteredCampaigns = filteredCampaigns.filter(
        (item) => item.name.toLowerCase() === name.toLowerCase()
      );
    }

    if (category) {
      filteredCampaigns = filteredCampaigns.filter(
        (item) => item.category.toLowerCase() === category.toLowerCase()
      );
    }

    setFilteredCampaigns(filteredCampaigns);
  }, [campaign, filterValue]);
  return (
    <>
      {loadingCauses ? (
        <div className="dark:bg-jacarta-800 bg-light-base rounded-2.5xl p-12 lg:w-1/3">
          <h2 className="text-jacarta-700 font-display mb-8 text-center text-3xl font-semibold dark:text-white">
            Top Causes
          </h2>

          <div className="flex flex-col space-y-5">
            <p></p>
          </div>
          <Link
            href="/causes"
            className="text-accent mt-8 block text-center text-sm font-bold tracking-tight"
          >
            View All
          </Link>
        </div>
      ) : (
        <>
          <div className="dark:bg-jacarta-800 bg-light-base rounded-2.5xl p-12 lg:w-1/3">
            <h2 className="mb-8 block font-display text-xl font-medium group-hover:text-accent dark:text-white  transition-colors text-center">
              Top Causes
            </h2>

            <div className="flex flex-col space-y-5">
              {filteredCampaigns.slice(0, 2).map((item, index) => {
                const { _id, logoUrl, name, icon, amount, category } = item;

                return (
                  <div
                    key={index}
                    className="border-jacarta-100 dark:bg-jacarta-700 rounded-2xl flex border bg-white py-4 px-7 transition-shadow hover:shadow-lg dark:border-transparent"
                  >
                    <figure className="mr-4 shrink-0">
                      <Link href={`causes/${_id}`} className="relative block">
                        <Image
                          width={48}
                          height={48}
                          src={`${baseURL}${logoUrl}`}
                          alt={`${name}`}
                          className="rounded-2lg h-12 w-12"
                        />
                        <div className="dark:border-jacarta-600 bg-jacarta-700 absolute -left-3 top-1/2 flex h-6 w-6 -translate-y-2/4 items-center justify-center rounded-full border-2 border-white text-xs text-white">
                          {index + 1}
                        </div>
                        {icon && (
                          <div
                            className="dark:border-jacarta-600 bg-green absolute -left-3 top-[60%] flex h-6 w-6 items-center justify-center rounded-full border-2 border-white"
                            data-tippy-content="Verified Collection"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              width="24"
                              height="24"
                              className="h-[.875rem] w-[.875rem] fill-white"
                            >
                              <path fill="none" d="M0 0h24v24H0z"></path>
                              <path d="M10 15.172l9.192-9.193 1.415 1.414L10 18l-6.364-6.364 1.414-1.414z"></path>
                            </svg>
                          </div>
                        )}
                      </Link>
                    </figure>
                    <div>
                      <Link href={`causes/${_id}`} className="block">
                        <span className="font-display text-jacarta-700 hover:text-accent font-semibold dark:text-white">
                          {name}
                        </span>
                      </Link>
                      <span className="dark:text-jacarta-300 text-sm">
                        {category}
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
            <Link
              href="/404"
              className="text-accent mt-8 block text-center text-sm font-bold tracking-tight"
            >
              View All
            </Link>
          </div>
        </>
      )}
    </>
  );
};

export default TopCauses;
